import { createReducer } from '@reduxjs/toolkit';
import {
  fetchVoucherCodeFailed,
  fetchVoucherCodeStarted,
  fetchVoucherCodeSucceeded,
  removeVodeCode,
  setBraintreeFieldsValid,
  setCheckoutDialog,
  setCheckoutRedirect,
  setPaymentAmount,
  setSavedCreditCards,
  setSurchargePaymentTypeId,
  setVoucherCodes,
  storeBraintreeClientToken,
} from '../../actions/checkout';

export const initialState = {
  braintreeClientToken: null,
  braintreeFieldsValid: false,
  redirect: false,
  dialogMessage: '',
  dialogHeader: '',
  dialogState: 0,
  surchargePaymentTypeId: null,
  paymentAmount: 'balance', // ['balance', 'deposit']
  savedCards: [],
  voucherCodes: [],
  voucherCodeStatus: null,
  voucherError: null,
};

const CheckoutReducer = createReducer(initialState, {
  [setPaymentAmount]: (state, action) => {
    state.paymentAmount = action.payload === 'deposit' ? 'deposit' : 'balance';
  },
  [storeBraintreeClientToken]: (state, action) => {
    state.braintreeClientToken = action.payload.client_token;
  },
  [setBraintreeFieldsValid]: (state, action) => {
    state.braintreeFieldsValid = action.payload;
  },
  [setCheckoutRedirect]: (state, action) => {
    state.redirect = action.payload;
  },
  [setCheckoutDialog]: (state, action) => {
    state.dialogMessage = action.payload.message;
    state.dialogHeader = action.payload.header;
    state.dialogState = action.payload.state;
  },
  [setSurchargePaymentTypeId]: (state, action) => {
    state.surchargePaymentTypeId = action.payload;
  },
  [setSavedCreditCards]: (state, action) => {
    state.savedCards = action.payload;
  },
  [fetchVoucherCodeStarted]: (state) => {
    state.voucherCodeStatus = 'started';
  },
  [fetchVoucherCodeSucceeded]: (state) => {
    state.voucherCodeStatus = 'succeeded';
  },
  [fetchVoucherCodeFailed]: (state, action) => {
    state.voucherCodeStatus = 'failed';
    state.voucherError = action.payload;
  },
  [setVoucherCodes]: (state, action) => {
    state.voucherCodes = [...state.voucherCodes, action.payload];
    state.voucherCodeStatus = null;
    state.voucherError = null;
  },
  [removeVodeCode]: (state, action) => {
    state.voucherCodes = state.voucherCodes.filter(
      (voucherCode) => voucherCode.voucherCode !== action.payload
    );
  },
});

export default CheckoutReducer;
